module.exports = __webpack_public_path__ + "static/media/Pic1.3249a1e2.jpg";